const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.1556 19.3519C15.1556 19.3519 15.1556 19.3024 15.1556 19.2034C15.1556 19.1043 15.1022 19.0281 14.9954 18.9748H6.24486C7.12945 18.3118 7.6747 17.4622 7.88059 16.4259C7.88059 16.4183 7.88059 16.4069 7.88059 16.3917C7.88059 16.3764 7.88441 16.365 7.89203 16.3574C7.89203 16.2659 7.82721 16.2202 7.69757 16.2202H7.66326C7.59463 16.2202 7.54887 16.224 7.52599 16.2316C7.50312 16.2393 7.48024 16.2545 7.45736 16.2774C7.43448 16.3002 7.42305 16.3345 7.42305 16.3802C7.42305 16.4259 7.41161 16.4869 7.38873 16.5631C7.36585 16.6393 7.33535 16.7345 7.29722 16.8488C7.12945 17.3594 6.85111 17.8166 6.4622 18.2204C6.07328 18.6243 5.61955 18.91 5.10099 19.0776C5.03236 19.1005 4.99805 19.1424 4.99805 19.2034C4.99805 19.2491 5.01711 19.2834 5.05524 19.3062C5.09337 19.3291 5.18488 19.3672 5.32977 19.4205C5.47466 19.4739 5.61955 19.5462 5.76444 19.6377C6.0771 19.8358 6.34781 20.0644 6.57658 20.3235C6.80536 20.5825 6.97694 20.8378 7.09132 21.0893C7.20571 21.3407 7.28578 21.5312 7.33154 21.6607C7.37729 21.7903 7.40779 21.9084 7.42305 22.0151C7.4383 22.0913 7.45736 22.137 7.48024 22.1522C7.50312 22.1675 7.56412 22.1789 7.66326 22.1865C7.81577 22.1865 7.89203 22.1446 7.89203 22.0608C7.89203 22.0074 7.87297 21.9122 7.83484 21.775C7.59081 20.8149 7.06082 20.0339 6.24486 19.432H14.9954C15.1022 19.3786 15.1556 19.3024 15.1556 19.2034V19.3519Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.3861 19.3526C27.3861 19.3526 27.3861 19.3031 27.3861 19.204C27.3861 19.1049 27.2807 19.0287 27.0701 18.9754H13.9578C13.7321 19.0364 13.6193 19.1126 13.6193 19.204C13.6193 19.2954 13.7321 19.3716 13.9578 19.4326H27.0701C27.2807 19.3793 27.3861 19.3031 27.3861 19.204V19.3526Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.1556 19.2034C15.1556 19.3024 15.1556 19.3519 15.1556 19.3519V19.2034ZM15.1556 19.2034C15.1556 19.1043 15.1022 19.0281 14.9954 18.9748H6.24486C7.12945 18.3118 7.6747 17.4622 7.88059 16.4259C7.88059 16.4183 7.88059 16.4069 7.88059 16.3917C7.88059 16.3764 7.88441 16.365 7.89203 16.3574C7.89203 16.2659 7.82721 16.2202 7.69757 16.2202H7.66326C7.59463 16.2202 7.54887 16.224 7.52599 16.2316C7.50312 16.2393 7.48024 16.2545 7.45736 16.2774C7.43448 16.3002 7.42305 16.3345 7.42305 16.3802C7.42305 16.4259 7.41161 16.4869 7.38873 16.5631C7.36585 16.6393 7.33535 16.7345 7.29722 16.8488C7.12945 17.3594 6.85111 17.8166 6.4622 18.2204C6.07328 18.6243 5.61955 18.91 5.10099 19.0776C5.03236 19.1005 4.99805 19.1424 4.99805 19.2034C4.99805 19.2491 5.01711 19.2834 5.05524 19.3062C5.09337 19.3291 5.18488 19.3672 5.32977 19.4205C5.47466 19.4739 5.61955 19.5462 5.76444 19.6377C6.0771 19.8358 6.34781 20.0644 6.57658 20.3235C6.80536 20.5825 6.97694 20.8378 7.09132 21.0893C7.20571 21.3407 7.28578 21.5312 7.33154 21.6607C7.37729 21.7903 7.40779 21.9084 7.42305 22.0151C7.4383 22.0913 7.45736 22.137 7.48024 22.1522C7.50312 22.1675 7.56412 22.1789 7.66326 22.1865C7.81577 22.1865 7.89203 22.1446 7.89203 22.0608C7.89203 22.0074 7.87297 21.9122 7.83484 21.775C7.59081 20.8149 7.06082 20.0339 6.24486 19.432H14.9954C15.1022 19.3786 15.1556 19.3024 15.1556 19.2034ZM27.3861 19.204C27.3861 19.3031 27.3861 19.3526 27.3861 19.3526V19.204ZM27.3861 19.204C27.3861 19.1049 27.2807 19.0287 27.0701 18.9754H13.9578C13.7321 19.0364 13.6193 19.1126 13.6193 19.204C13.6193 19.2954 13.7321 19.3716 13.9578 19.4326H27.0701C27.2807 19.3793 27.3861 19.3031 27.3861 19.204Z",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 13 15)",
  stroke: "#0081CC"
});

const SvgEquationOperator2 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationOperator2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-operator-2.803c7a9e.svg";
export { ForwardRef as ReactComponent };